<template>
    <div v-loading="loading" class="card-deal contact-edit">
        <div class="card-deal-header caption-block">
            <div class="title">
                Карточка контакта
            </div>
            <div class="actions">
                <span class="btn btn-default orange action-edit" @click="save" v-if="canEdit">
                    {{ saveBtnText }}
                </span>
                <div class="btn btn-default grey action-close" @click="close">
                    Отменить
                </div>
            </div>
        </div>
        <el-row class="tasks-wrapper tasks-edit mobile-wrapper">
            <el-row justify="start" class="card task-main-info">
                <el-form :model="contact" label-position="top">
                    <el-row class="task-item-row row">
                        <el-col :span="24" justify="start" class="fab">
                            <div class="label">
                                Имя
                            </div>
                            <div :class="{ 'error-input': errors.name }">
                                <el-input v-model="contact.name" size="mini" autocomplete="off" />
                                <div class="error" v-if="errors.name">
                                    {{ errors.name[0] }}
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row class="task-item-row row phones">
                        <div class="label">
                            Телефон
                        </div>
                        <template v-for="(contactPhone, index) in contact.contact_phones">
                            <div :key="index" class="tel-item">
                                <el-col :span="20" :class="['mb10', { 'error-input': errors.phone }]">
                                    <div class="el-input el-input--mini">
                                        <the-mask
                                            v-model="contactPhone.phone"
                                            mask="+# (###) ###-##-##"
                                            placeholder="+7 (495) 123-45-67"
                                            class="el-input__inner"
                                        />
                                    </div>
                                </el-col>
                                <el-col :span="2" class="icon-phone">
                                    <div class="pt5 pl5 pointer" @click="calltoPhone(contactPhone.phone)">
                                        <font-awesome-icon icon="phone" class="orange" title="Позвонить" />
                                    </div>
                                </el-col>
                                <el-col :span="2" v-if="!isMain(contactPhone)" class="icon-delete">
                                    <div class="delete-phone" @click="deletePhone(index, contactPhone)">
                                        <i class="el-icon-close"></i>
                                    </div>
                                </el-col>
                            </div>
                            <template>
                                <div class="field-error" v-if="errors[`contact_phones.${index}.phone`]" :key="index+'error'">
                                    {{ errors[`contact_phones.${index}.phone`][0] }}
                                </div>
                            </template>
                        </template>
                        <div class="ml0">
                            <el-col>
                                <el-button class="button-icon" size="mini" @click="addNewPhone">
                                    <font-awesome-icon icon="plus" class="orange" />
                                </el-button>
                            </el-col>
                        </div>
                    </el-row>
                    <el-row class="task-item-row row">
                        <el-col :span="24" :class="['fab', { 'error-input': errors.email }]">
                            <div class="label">
                                E-mail
                            </div>
                            <el-input size="mini" autocomplete="off" v-model="contact.email" />
                            <div class="error" v-if="errors.email">
                                {{ errors.email[0] }}
                            </div>
                        </el-col>
                    </el-row>
                    <el-row class="task-item-row row">
                        <el-col :span="24" :class="['fab', { 'error-input': errors.birthday }]">
                            <div class="label">
                                День рождения
                            </div>
                            <el-date-picker
                                v-model="contact.birthday"
                                type="date"
                                placeholder="день.месяц.год"
                                clearable
                                format="dd.MM.yyyy"
                                value-format="timestamp"
                                size="mini"
                                class="w100"
                                :picker-options="pickerOptions"
                            />
                            <div class="error" v-if="errors.birthday">
                                {{ errors.birthday[0] }}
                            </div>
                        </el-col>
                    </el-row>
                    <el-row class="task-item-row row">
                        <el-col :span="24" :class="['fab', { 'error-input': errors.company_id }]">
                            <div class="label">
                                Компания
                            </div>
                            <el-select
                                v-model="contact.company_id"
                                filterable
                                remote
                                reserve-keyword
                                size="mini"
                                placeholder="Введите название компании"
                                :remote-method="searchCompany"
                            >
                                <el-option
                                    v-for="item in companyOptions"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                />
                            </el-select>
                            <div class="error" v-if="errors.company_id">
                                {{ errors.company_id[0] }}
                            </div>
                        </el-col>
                    </el-row>
                </el-form>
            </el-row>
            <el-col :span="24" class="card-comment" :class="['card','task-comment','task-item-row','row', { 'error-input': errors.comment }]">
                <div class="label">
                    Комментарий
                </div>
                <el-input
                    size="mini"
                    type="textarea"
                    :autosize="{ minRows: 2, maxRows: 4}"
                    placeholder=""
                    v-model="contact.comment"
                />
                <div class="error" v-if="errors.comment">
                    {{ errors.comment[0] }}
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import CardEdit from './CardEdit';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCheck, faPlus, faPhone } from '@fortawesome/free-solid-svg-icons';

library.add(faCheck, faPlus, faPhone);

export default {
    name: 'ContactsCardEditMobile',
    extends: CardEdit
};
</script>
